<div class="top-section service-page">

    <section class="healthcare-banner instool aashi">
        <div class="container">
            <div class="row hero-img-wrapper zmc">
                <div class="col-lg-7 col-md-7 col-sm-7  col-12 service-heading">
                    <div class="headtext">
                        <h1>Microsoft Dynamics</h1>
                        <p>Microsoft Dynamics is a suite of enterprise resource planning (ERP) and customer relationship management (CRM) software applications that help businesses streamline operations, manage customer relationships, and drive growth.</p>

                        <a class="ar_contect-industries-header" 
                        routerLink="/contact-us.html"><span>Contact Us</span></a>

                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-12">
                    <div class="right-img frontend-heroimg">
                        <img src="../../../assets/images/services/6493510-removebg-preview.png" loading="lazy"
                            alt="Ecommerce Website Development Service Header Image">
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<section class="services-row">
    <div class="container">
        <!-- <app-services-content-point [firstMAtchData]="firstMAtch"></app-services-content-point> -->

        <div class="softeare-developemnt-isv-main">
            <div class="row">
                <div class="col-lg-12 headingsec">
                    <h2>Microsoft Dynamics Native Integrations and Features</h2>
                    <!-- <p>It combines the traditional Office suite of applications with advanced cloud services,
                        collaboration tools, and intelligent capabilities. Here's an overview of its functionality and
                        key features</p> -->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 softeare-developemnt-isv">
                    <ul>
                        <li class="mobi">
                            <div class="img-box-isv">
                                <img src="../../../assets/images/services/jpeg-optimizer_20945549.jpg" loading="lazy"
                                    alt="Ecommerce Application Development">

                            </div>
                        </li>
                        <li>
                            <h3>Account and Contact Management</h3>
                            <p>Maintain comprehensive records of accounts and contacts for personalized engagement.
                            </p>
                            <h3>Sales Insights</h3>
                            <p>AI-powered insights to help sales teams prioritize activities and improve performance.
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 softeare-developemnt-isv">
                    <ul>
                        <li>
                            <h3>Sales Automation</h3>
                            <p> Streamline repetitive tasks, such as quotes and proposals, to boost productivity.</p>
                        </li>
                        <li>
                            <h3>Dynamics 365</h3>
                            <p>Dynamics 365 is a cloud-based suite of applications that combines CRM and ERP capabilities into a unified platform.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="quote-box" style="    background-color: #0d052a;">
    <div class="container">
        <div class="row">
            <div class="col-md-9">
                <h4>Are You Ready To Discuss Your Project With Us?</h4>
            </div>
            <div class="col-md-3">
                <button routerLink="/hire-react-js-developers.html">Hire Our Experts</button>
            </div>
        </div>
    </div>
</section> -->
<section class="services-row services-row-new white_bg border-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>Dynamics 365 for Customer Service</h2>
                <!-- <p>We use best technologies to develop User Interface applications for every industry. </p> -->
            </div>
            <div class="col-lg-12 smart-software-product-isv frontend-tech ">
                <ul>
                    <li>
                        <img src="../../../assets/images/services/case-mgt.png" alt="HTML">
                        <h3>Case Management</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/knowledge-base.png" alt="CSS">
                        <h3>Knowledge Base</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/omni-chanel.png" alt="Javascript">
                        <h3>Omni-channel Support</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/custom-insight.png" alt="React">
                        <h3>Customer Insights</h3>
                    </li>
                    <!-- <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Angular">
                        <h3>Dynamics 365 Human Resources</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Vue">
                        <h3>Dynamics 365 Commerce</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Scss">
                        <h3>Dynamics 365 Project Operations</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Bootstrap">
                        <h3>Dynamics 365 Customer Service</h3>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="services-row services-row-new white_bg border-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>Dynamics 365 for Finance and Operations</h2>
                <!-- <p>We use best technologies to develop User Interface applications for every industry. </p> -->
            </div>
            <div class="col-lg-12 smart-software-product-isv frontend-tech ">
                <ul>
                    <li>
                        <img src="../../../assets/images/services/finance.png" alt="HTML">
                        <h3>Financial Management</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/supply-chain.png" alt="CSS">
                        <h3>Supply Chain Management</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/project.png" alt="Javascript">
                        <h3>Project Management:</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/manufacturing-bmgt.png" alt="React">
                        <h3>Manufacturing Managemen</h3>
                    </li>
                    <!-- <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Angular">
                        <h3>Dynamics 365 Human Resources</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Vue">
                        <h3>Dynamics 365 Commerce</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Scss">
                        <h3>Dynamics 365 Project Operations</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Bootstrap">
                        <h3>Dynamics 365 Customer Service</h3>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</section>




<!-- <app-why-choose-us></app-why-choose-us> -->

<section class="services-row services-row-new">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>key functionalities and features</h2>
                <!-- <p>Here’s what you get when you choose us as your preferred business partner:</p> -->
            </div>
        </div>
        <div class="row uses-box">
            <div class="col-lg-7 col-md-7 col-sm-12 whychoose-isv uses-conent">
                <ul>
                    <li>
                        <h3>Marketing Automation</h3>
                        <p>Plan and execute multi-channel marketing campaigns with targeted messaging.
                        </p>
                    </li>
                    <li>
                        <h3>Lead Scoring and Nurturing</h3>
                        <p> Identify high-potential leads and guide them through the sales funnel.
                        </p>
                    </li>
                    <li>
                        <h3>Event Management</h3>
                        <p> Plan, promote, and manage events, webinars, and trade shows.</p>
                    </li>
                    <li>
                        <h3>Analytics and Reporting</h3>
                        <p>Measure campaign performance and optimize strategies with data-driven insights.</p>
                    </li>
                    <li>
                        <h3>Work Order Management</h3>
                        <p>Schedule, dispatch, and track work orders for field service teams.
                        </p>
                    </li>
                    <li>
                        <h3>Resource Scheduling</h3>
                        <p> Optimize scheduling for resources, vehicles, and equipment.</p>
                    </li>
                </ul>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-12 img-box-container img-content">
                <div class="img-box-why-chosse">
                    <img src="../../../assets/images/services/4430764.jpg" loading="lazy" alt="Product Web Development">
                </div>
            </div>
        </div>
    </div>

</section>